module.exports = __webpack_public_path__ + "img/BRCA4_Fibroblasts.d4767385.png";